module.exports = __webpack_public_path__ + "department_teal.ce229a2ff7a15ba38604.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/department_teal.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/department_teal.svg
// module chunks = styles